module.exports = __webpack_public_path__ + "img/bottom_flower_001.27a099f7.svg";